
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Wichtig ist, alles zu vermeiden, was das Nervensystem zu stark oder zu plötzlich
aktiviert. Konkret heisst das: Ein möglichst «ausbalancierter Lebensstil» mit
gleichmässigen Tagesabläufen. Wichtig sind regelmässige Essens-, Pausen- und
Schlafenszeiten. Auch am Wochenende sollte der Wecker also so gestellt werden
wie sonst. Ausserdem hilft es, die Dinge gelassener zu nehmen Älter werden kann
ebenfalls ein Segen sein: Von den 15- bis 49-Jährigen in der Schweiz gab in
einer Umfrage fast jeder Zweite an, in den letzten vier Wochen Kopfschmerzen
gehabt zu haben, bei den 50- bis 64-Jährigen war es «nur» noch jeder Vierte und
von den über 65-Jährigen jeder Siebte.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;